import { Component, OnInit, OnDestroy, Output, Input, EventEmitter, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

import { Permissions } from '../../model/permissions';
import { Device } from '../../model/device';
import { DevicesService } from '../../services/devices.service';
import { HighchartExampleComponent } from '../../highchart-example/highchart-example.component';
import { TableViewComponent } from '../table-view/table-view.component';
import * as moment from 'moment';

@Component({
	selector: 'app-table-view-summary',
	templateUrl: './table-view-summary.component.html',
	styleUrls: ['./table-view-summary.component.css'],
})
export class TableViewSummaryComponent implements OnInit, OnDestroy {
	permissions = new Permissions();
	@ViewChild(HighchartExampleComponent) highchartExampleComponent: HighchartExampleComponent;
	@Output() updateParentDevice: EventEmitter<Device> = new EventEmitter();

	@Input() device: Device;
	@Input() open: any;
	@Input() model: any;
	public hasError: boolean;
	public message: string = '';
	public device_id: number;
	public interval: any;
	public statusTime;
	public measurement$: Observable<string>;
	public measurebtn = 'Measure';
	public suspend_resume = 'Suspend Measurement';
	public measurement_error_msg = 'Unable to take measurement. Please make sure the device is connected';

	constructor(private devicesService: DevicesService, private activeRoute: ActivatedRoute) {}

	ngOnInit() {
		console.log("TABLE VIEW SUMMARY SET INERVAL");
		this.device_id = this.device.device_id;

		this.changeSuspendBtnLbl();

		
		this.startIntevalUpdate();

		this.devicesService.deviceTime.subscribe((t) => {
			t.filter((tt) => tt.device_id === this.device_id).map((tt) => (this.statusTime = tt.deviceTimestamp));
		});
	}

	takeSmuMeasurement(device) {
		console.log('takemeasurement', device);

		const channel = 'MB_DC/version';
		const stream = this.devicesService.getStreambyGateWayID(device.gateway_id, channel);
		
		stream.subscribe(
			(x) => {
				if (x && x['status'] == 'success') {
					const mb_dc_version = x['value'];
					
					// Check version and proceed accordingly
					if (this.isVersionAtLeast(mb_dc_version, '3.0.7')) {
						const deviceLockStatus = this.devicesService.getDeviceLockStatus(device.device_id, device.device_dia_name);
						deviceLockStatus.subscribe(
							(x) => {
								console.log('----------------------', x);
			
								if (x['status'] != 'success') {
									this.measurebtn = 'Measure';
									this.hasError = true;
									this.message = x['message'];
									console.log(x);
									let int = setInterval(() => { 
										clearInterval(int); 
										this.hasError = false;
										this.message = '';
									}, 10000);
								} else if (x['lockedStatus'] !== 'unlocked') {
									// Device is locked - cannot take measurement
									this.measurebtn = 'Measure';
									this.hasError = true;
									this.message = 'Cannot take measurement. Device is currently locked.';
									console.log('Device is locked:', x);
									let int = setInterval(() => { 
										clearInterval(int); 
										this.hasError = false;
										this.message = '';
									}, 10000);
									// this.suspend_resume = 'Resume Measurement';
									this.updateDevice(() => {
										this.changeSuspendBtnLbl();
									});
								} else {
									// Device is unlocked - proceed with measurement
									this.measurebtn = 'Measuring...';
									this.message = '';
			
									console.log('[DEBUG] v>=3.0.7 path — device.timestamp:', this.device.timestamp, typeof this.device.timestamp);
									this.measurement$ = this.devicesService.takeMeasurement(device.device_id, new Date().getTime());
									this.measurement$.subscribe(
										(x) => {
											console.log('----------------------', x);
											if (x !== 'success') {
												this.measurebtn = 'Measure';
												this.hasError = true;
												this.message = this.measurement_error_msg;
												console.log(x);
												// let int = setInterval(() => { clearInterval(int); this.hasError = false; this.message = ''; }, 10000);
											} else {
												this.refreshData();
											}
										},
										() => {
											this.measurebtn = 'Measure';
											this.hasError = true;
											this.message = this.measurement_error_msg;
											// let int = setInterval(() => { clearInterval(int); this.hasError = false; this.message = ''; }, 10000);
										}
									);
								}
							},
							(err) => {
								console.log('err', err);
								this.measurebtn = 'Measure';
								this.hasError = true;
								this.message = err.message;
								let int = setInterval(() => { 
									clearInterval(int); 
									this.hasError = false;
									this.message = '';
								}, 10000);
							}
						);
					} else {
						console.log('mb_dc_version: ', mb_dc_version);

						this.measurebtn = 'Measuring...';
						this.message = '';
						console.log('[DEBUG] v<3.0.7 path — device.timestamp:', this.device.timestamp, typeof this.device.timestamp);
						this.measurement$ = this.devicesService.takeMeasurement(device.device_id, new Date().getTime());
						this.measurement$.subscribe(
							(x) => {
								console.log('----------------------');
								if (x !== 'success') {
									this.measurebtn = 'Measure';
									this.hasError = true;
									this.message = this.measurement_error_msg;
									console.log(x);
									// let int = setInterval(() => { clearInterval(int); this.hasError = false; this.message = ''; }, 10000);
								} else {
									this.refreshData();
								}
							},
							() => {
								this.measurebtn = 'Measure';
								this.hasError = true;
								this.message = this.measurement_error_msg;
								// let int = setInterval(() => { clearInterval(int); this.hasError = false; this.message = ''; }, 10000);
							}
						);
					}
				} else {
					console.log('x[status] not there', x);
				}
			},
			(err) => {
				console.log('err', err);
			}
		);
	}

	loadChart(did, open) {
		if (open) {
			// this.highchartExampleComponent.updateSearch(did);
		}
	}

	refreshData() {
		let counter = 0;
		let timer = setInterval(() => {
			console.log("counter", counter, 'tries', this.getNumberOfTries());
			if (counter > this.getNumberOfTries()) {
				clearInterval(timer);
				this.measurebtn = 'Measure';
				this.hasError = true;
				this.message = `It is taking too long to update ${this.device.device_name}. Try again or contact administrator.`;
			}
			counter++;
			// console.log({ counter }, { try: this.getNumberOfTries() });
			this.devicesService.getDeviceStatusTime(this.device_id);
			let _tmp = JSON.parse(localStorage.getItem('measuring'));

			// console.log('TEMPPPPPP')
			// console.log(_tmp)
			console.log('----------------------')

			// console.log('DEVICE ID - ', this.device_id)

			if (_tmp) {
				// this.measurebtn = 'Measuring...';
				_tmp.forEach((x, i) => {
					// console.log('[DEBUG] refreshData compare — device_id:', x.device_id, 'smu_timeStamp:', x.smu_timeStamp, '(' + typeof x.smu_timeStamp + ')', 'newTimeStamp:', x.newTimeStamp, '(' + typeof x.newTimeStamp + ')', 'result:', Number(x.smu_timeStamp) < Number(x.newTimeStamp));
					if (x.device_id == this.device_id && Number(x.smu_timeStamp) < Number(x.newTimeStamp)) {
						// console.log('CONDITION MET')
						this.updateDevice();
						clearInterval(timer);

						_tmp.splice(i, 1);
						localStorage.setItem('measuring', JSON.stringify(_tmp));
						this.hasError = false;
						this.message = `The information for ${this.device.device_name} has been updated successfully.`;
						this.measurebtn = 'Measure';
						// let int = setInterval((x)=>{ clearInterval(int); this.hasError = false,this.message=''},30000)
					}
					// console.log('time diff', counter, x.device_id, x.smu_timeStamp, x.newTimeStamp, x.smu_timeStamp - x.newTimeStamp);
				});
			}
		}, 10000);
	}

	startIntevalUpdate() {
		this.interval = setInterval(() => {
			// console.log('table - view - summary - time', this.device_id, this.statusTime,this.device.getLatestDeviceTime(), this.statusTime - this.device.getLatestDeviceTime())
			if (this.device.getLatestDeviceTime() && this.statusTime > this.device.getLatestDeviceTime()) {
				this.updateDevice();
				// let newDeviceValue = this.devicesService.returnDeviceByID(this.device_id);
			}
		}, 5000);
	}

	updateDevice(cb?: Function) {
		let newDeviceValue = this.devicesService.returnDeviceByID(this.device.device_id);

		newDeviceValue.subscribe((x) => {
			this.devicesService.devices.subscribe((devices) => {
				devices
					.filter((d) => d.device_id === this.device.device_id)
					.map((d) => {
						// d = this.device;
						this.device = Object.assign(d, x[0]);
						if (this.open.open && this.open.open == true && typeof x[0] !== 'undefined') {
							let d = new Date();
							// this.highchartExampleComponent.model.endDate = new Date(d);
							this.highchartExampleComponent.model.endDate = {
                				year: new Date(d).getFullYear(),
                				month: new Date(d).getMonth(),
								day: new Date(d).getDay(),
								hour:new Date(d).getHours(),
								minute:new Date(d).getMinutes(),
								isoDate: moment(d).toISOString(),
								displayDate: moment(d).format('MM/DD/YYYY HH:mm'),
								
              				};
							this.highchartExampleComponent.add(x[0]);
						}
					});
			});
			if (cb) {
				cb();
			}
		});
	}

	clearMessage() {
		this.message = '';
		this.hasError = null;
	}

	ngOnDestroy() {
		if (this.interval) {
			clearInterval(this.interval);
		}
	}

	getNumberOfTries(): number {
		let height = this.device.height;
  
		// If height is 0 or not set, assume worst case of 150 ft
		if (!height || height === 0) {
		  if (this.device.linear_uom.trim().toUpperCase() === 'F') {
			height = 150; // Default 150 feet
		  } else {
			height = 45.72; // Default 150 feet, but converted to meters for consistency
		  }
		}
		
		let tries = 10;
		if (this.device.linear_uom.trim().toUpperCase() === 'F') {
			tries = height * 3;
		} else {
			tries = height * 3.28084 * 3;
		}
		tries = tries >= 10 ? Math.trunc(tries) : 10;
		return tries;

		// let tries = 10;
		
		// if (this.device.linear_uom.trim().toUpperCase() === 'F') {
		//   // Height is already in feet
		//   tries = Math.ceil((height + 10) / 3) + 5; // +5 retries buffer
		// } else {
		//   // Height is in meters, convert to feet
		//   let heightInFeet = height * 3.28084;
		//   tries = Math.ceil((heightInFeet + 10) / 3) + 5; // +5 retries buffer
		// }
		
		// tries = tries >= 10 ? Math.trunc(tries) : 10;
		// return tries;
	}

	suspendMeasurement() {
		let action = '';
		this.hasError = false;
		this.message = '';
		const islocked = this.device.islocked === 1 ? 0 : 1;
		this.devicesService.suspendMeasurement(this.device_id, islocked).subscribe(
			(res) => {
				const data = res.data;
				if (data.status === 'error') {
					let action = this.device.islocked === 1 ? 'resume' : 'suspend';
					this.hasError = true;
					this.message = this.message = `Unable to ${action} measurement`;
				} else {
					let action = this.device.islocked === 1 ? 'resumed' : 'suspended';
					this.hasError = false;
					this.message = this.message = `Measurement has been ${action}`;
					this.device.islocked = islocked;
					this.changeSuspendBtnLbl();
				}
			},
			(err) => {
				action = this.device.islocked === 1 ? 'resume' : 'suspend';
				this.hasError = true;
				this.message = `Unable to ${action} measurement`;
			}
		);
	}

	changeSuspendBtnLbl() {
		this.suspend_resume = 'Suspend Measurement';
		if (this.device.islocked === 1) {
			this.suspend_resume = 'Resume Measurement';
		}
	}

	/**
	 * Compares two semantic version strings.
	 * Returns true if version >= minVersion
	 */
	private isVersionAtLeast(version: string, minVersion: string): boolean {
		const v1Parts = version.split('.').map(Number);
		const v2Parts = minVersion.split('.').map(Number);

		for (let i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
			const v1 = v1Parts[i] || 0;
			const v2 = v2Parts[i] || 0;
			if (v1 > v2) return true;
			if (v1 < v2) return false;
		}
		return true; // versions are equal
	}
}
